// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1zoul","boxTitle":"Qualiphy_boxTitle__1l6G6","box":"Qualiphy_box__fQQtN","toggleWrap":"Qualiphy_toggleWrap__3LF8u"};